<i18n>
  {
    "pt_BR": {
      "label": "Cadastre sua senha:",
      "text": "Mostrar",
      "password": "Esconder",
      "confirmation": "Repita a sua senha:"
    }
  }
</i18n>

<template>
  <div class="signup-form--step step-3 active">
    <div class="signup-input--container">
      <label for="signupPassInput" class="signup-input--label" v-t="'label'"></label>
      <div class="signup-input--fields">
        <input id="signupPassInput" name="senha" :type="type" class="signup-input--field" v-model="form.password" required>
        <p id="showPassword" class="btn--show-password" v-t="type" @click.prevent="toggle"></p>
      </div>
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('password')"></p>
      <p class="login-input--error" v-if="! form.has('password')"></p>
    </div>

    <div class="signup-input--container">
      <label for="signupPassInput" class="signup-input--label" v-t="'confirmation'"></label>
      <div class="signup-input--fields">
        <input id="signupPassInput" name="senha" :type="type" class="signup-input--field" v-model="form.password_confirmation" required>
        <p id="showPassword" class="btn--show-password" v-t="type" @click.prevent="toggle"></p>
      </div>
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('password_confirmation')"></p>
      <p class="login-input--error" v-if="! form.has('password_confirmation')"></p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      form: {
        required: true,
      },
    },

    data: () => ({
      show: false,
    }),

    computed: {
      type () {
        return this.show ? 'text' : 'password';
      },
    },

    methods: {
      toggle () {
        this.show = ! this.show;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Auth/Steps/Third.vue